import { SPECIES_SERVICE } from "@/services/species.service.js";

const state = {getSpeciesOutput: {}, postSpecieOutput: false, putSpecieOutput: false, getSpecieByIdOutput: {}, deleteSpecieByIdOutput: false};

const actions = {
    //Service to get paginated species
    getSpecies({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getSpeciesRequest');

        SPECIES_SERVICE.getSpecies(queryParams)
            .then(
                output => {
                    commit('getSpeciesSuccess', output);
                },
                error => {
                    commit('getSpeciesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to create species
    postSpecie({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postSpecieRequest');

        SPECIES_SERVICE.postSpecie(input)
            .then(
                output => {
                    commit('postSpecieSuccess', output);
                },
                error => {
                    commit('postSpecieFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update species
    putSpecie({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putSpecieRequest');

        SPECIES_SERVICE.putSpecie(input)
            .then(
                output => {
                    commit('putSpecieSuccess', output);
                },
                error => {
                    commit('putSpecieFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get specie details
    getSpecieById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getSpecieByIdRequest');

        SPECIES_SERVICE.getSpecieById(queryParams)
            .then(
                output => {
                    commit('getSpecieByIdSuccess', output);
                },
                error => {
                    commit('getSpecieByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete species
    deleteSpecieById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteSpecieByIdRequest');

        SPECIES_SERVICE.deleteSpecieById(queryParams)
            .then(
                output => {
                    commit('deleteSpecieByIdSuccess', output);
                },
                error => {
                    commit('deleteSpecieByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getSpecies
    getSpeciesRequest(state) {
    },
    getSpeciesSuccess(state, output) {
        state.getSpeciesOutput = output;
    },
    getSpeciesFailure(state) {
        state.getSpeciesOutput = false;
    },

    //postSpecie
    postSpecieRequest(state) {
        state.postSpecieOutput = null;
    },
    postSpecieSuccess(state, output) {
        state.postSpecieOutput = true;
    },
    postSpecieFailure(state) {
        state.postSpecieOutput = false;
    },

    //putSpecie
    putSpecieRequest(state) {
        state.putSpecieOutput = null;
    },
    putSpecieSuccess(state, output) {
        state.putSpecieOutput = true;
    },
    putSpecieFailure(state) {
        state.putSpecieOutput = false;
    },

    //getSpecieById
    getSpecieByIdRequest(state) {
    },
    getSpecieByIdSuccess(state, output) {
        state.getSpecieByIdOutput = output;
    },
    getSpecieByIdFailure(state) {
        state.getSpecieByIdOutput = false;
    },

    //deleteSpecieById
    deleteSpecieByIdRequest(state) {
        state.deleteSpecieByIdOutput = null;
    },
    deleteSpecieByIdSuccess(state, output) {
        state.deleteSpecieByIdOutput = true;
    },
    deleteSpecieByIdFailure(state) {
        state.deleteSpecieByIdOutput = false;
    },
};

export const species = {
    namespaced: true,
    state,
    actions,
    mutations
};